import '@/assets/styles/global.less';
import SquareMenu from '@/components/SquareMenu';
import { LOGIN_PATH } from '@/constants';
import { getAssistantList } from '@/services/AssistantManagement';
import { getUserInfo } from '@/services/user'
import { getUserState } from '@/services/welcome';
import { userinfoMenu } from '@/services/global';
import { processMenuItems } from '@/utils/index';
import { RequestConfig, RuntimeReactQueryType } from '@umijs/max';
import { Access, useAccess, useModel, history } from '@umijs/max';
import { message } from 'antd';
import './assets/styles/antdStyle.less';

const redirectToLogin = () => {
  localStorage.clear();
  sessionStorage.clear();

  // 当前应用负责固定账号认证；统一使用构建环境对应的登录路径。
  if (location.pathname !== LOGIN_PATH) {
    window.location.replace(LOGIN_PATH);
  }
};

// 运行时配置
// 全局初始化数据配置，用于 Layout 用户信息和权限初始化
// 更多信息见文档：https://umijs.org/docs/api/runtime-config#getinitialstate
export async function getInitialState(): Promise<any> {
  let token = localStorage.getItem('user_token');

  if (!token) {
    redirectToLogin();
    return;
  }

  if (token) {

    getUserInfo().then((res) => {
      if (res.status === 0) {
        localStorage.setItem("user_info", JSON.stringify(res.payload));
      }
    });
    let userInfo = localStorage.getItem('user_info');
    userInfo = userInfo ? JSON.parse(userInfo) : {};
    if (!userInfo) {
      window.location.href = '/home';
    }
    let payload = {};
    let resData = {};
    let userState = {};
    try {
      const { payload: data } = await userinfoMenu();
      payload = data;
      resData = await getAssistantList({ keywords: '' });
      userState = await getUserState();
    } catch (error) {
      console.log('error :>> ', error);
    }
    return {
      haideMenuPath: [
        '/hotcreativeAssistant/welcome',
        '/hotcreativeAssistant/assistantInfo',
        '/hotcreativeAssistant/planPage',
        'assistantInfo',
        'planPage'
      ],
      userInfo,
      ...payload,
      layoutSider: {},
      userState,
      SquareMenu: resData?.payload?.list || [],
    };
  }
}

export const layout = ({ initialState }: { initialState: any }) => {
  const { addSquareModal, setAddSquareModal } = useModel('global');
  let renderData = {};
  if (initialState?.haideMenuPath?.some((j) => location.pathname.includes(j))) {
    renderData = {
      menuRender: false,
    };
  }

  return {
    menuHeaderRender: false,
    headerContentRender: false,
    rightContentRender: false,
    siderWidth: 200,
    onPageChange: (e) => {
      if (e.pathname === '/null') {
        message.info('该助手已被禁用')
      }
      if (e.pathname === '/create') {
        setAddSquareModal(true)
        history.push('/workbench')
      }
      if (!e.pathname.includes('/assistantInfo') && !e.pathname.includes('/planPage')) {
        localStorage.setItem('assistantDetailPrevPage', e.pathname);
      }
    },
    token: {
      sider: {
        // ...initialState.layoutSider,
        colorTextMenuSelected:
          process.env.PRODUCT_TYPE_ENV === 'mn' ? '#00b451' : '#0346FE',
        colorBgMenuItemSelected:
          process.env.PRODUCT_TYPE_ENV === 'mn'
            ? 'rgba(3, 70, 254, 0.1)'
            : 'rgba(3, 70, 254, 0.1)',
      },
    },
    menu: {
      locale: false,
      type: 'group',
      params: {
        params: initialState,
      },
      request: async (params: { pathname: any }, defaultMenuData: any[]) => {
        let menuList = [...defaultMenuData];
        if (initialState.menus?.length > 0) {
          menuList = initialState.menus.filter((j) =>
            j.description.includes('sys:page:'),
          ); // 过滤出不是菜单的权限
          // menuList = menuList.sort((a, b) => a.orders - b.orders); // 菜单排序
          menuList = processMenuItems(menuList);
        }
        if (initialState?.menus?.some((j) => j.path === '/assistantInfo')) {
          menuList = [
            ...menuList,
            ...SquareMenu(initialState.SquareMenu || []),
          ];
        }
        console.log('menuList :>> ', menuList);
        return menuList;
      },
    },
    ...renderData,
  };
};

export const reactQuery: RuntimeReactQueryType = {
  queryClient: {
    defaultOptions: {
      queries: {
        // 🟡 此配置具有的表现往往令人出乎意料，若无特殊需求，请默认关闭
        refetchOnWindowFocus: false,
      },
    },
  },
};

// 错误处理方案： 错误类型
enum ErrorShowType {
  SILENT = 0,
  WARN_MESSAGE = 1,
  ERROR_MESSAGE = 2,
  NOTIFICATION = 3,
  REDIRECT = 9,
}
// 与后端约定的响应数据格式
interface ResponseStructure {
  success: boolean;
  data: any;
  errorCode?: number;
  errorMessage?: string;
  showType?: ErrorShowType;
}

// 运行时配置
export const request: RequestConfig = {
  // 统一的请求设定
  timeout: 18000000,
  headers: {
    'Content-Type': 'application/json;charset=utf-8',
    Authorization: `Bearer ${localStorage.getItem('user_token')}`,
  },

  // 错误处理： umi@3 的错误处理方案。
  errorConfig: {
    // 错误抛出
    errorThrower: (res: ResponseStructure) => {
      const { success, data, errorCode, errorMessage, showType } = res;
      if (!success) {
        const error: any = new Error(errorMessage);
        error.name = 'BizError';
        error.info = { errorCode, errorMessage, showType, data };
        throw error; // 抛出自制的错误
      }
    },
    // 错误接收及处理
    errorHandler: (error: any, opts: any) => {
      if (opts?.skipErrorHandler) throw error;
      // 我们的 errorThrower 抛出的错误。
      if (error.response) {
        // Axios 的错误
        // 请求成功发出且服务器也响应了状态码，但状态代码超出了 2xx 的范围
        // message.error(`Response status:${error.response.status}`);
      } else if (error.request) {
        // 请求已经成功发起，但没有收到响应
        // \`error.request\` 在浏览器中是 XMLHttpRequest 的实例，
        // 而在node.js中是 http.ClientRequest 的实例
        //message.error('None response! Please retry.');
      } else {
        // 发送请求时出了点问题
        //message.error('Request error, please retry.');
      }
    },
  },

  // 请求拦截器
  requestInterceptors: [
    (config: any) => {
      // 拦截请求配置，进行个性化处理。

      return { ...config };
    },
  ],

  // 响应拦截器
  responseInterceptors: [
    (response) => {
      // 拦截响应数据，进行个性化处理
      const { data, request }: any = response;
      const errMsg = data?.message;
      if (request.responseURL.includes('/oss/api/')) {
        if (data?.code && data?.code === 401) {
          // 登录失效时回到固定账号登录入口。
          redirectToLogin();
          message.error('登录失效，请重新登录！');
        } else if (data?.code && data?.code !== 200) {
          message.error(errMsg ? errMsg : '请求失败！');
          return null;
        } else if (data?.status && data?.status !== 200) {
          message.error(errMsg ? errMsg : '请求失败！');
          return null;
        }
      } else {
        if (data?.status === 401) {
          redirectToLogin();
        } else if (data?.status && data?.status !== 0) {
          message.error(errMsg ? errMsg : '请求失败！');
          return response;
        }
      }
      return response;
    },
  ],
};

export function render(oldRender: () => void) {
  oldRender();
}
